module.exports = __webpack_public_path__ + "static/M3-05-image-a51f82a56a3b6516298e4ea05b949150.png";